import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const CHIP_FONT_SIZE_IN_PIXELS = 13

const useStyles = makeStyles({
	instanceChip: {
		padding: "0rem 0.625rem",
		backgroundColor: colors.purple[100],
		borderRadius: "1.25rem"
	},
	instanceChipText: {
		fontSize: CHIP_FONT_SIZE_IN_PIXELS,
		fontWeight: 600,
		color: colors.purple[400]
	}
})

export default useStyles
